$(document).ready(function(){

  $('.tb_popup_close').click(function(){
    $('.tb_popup_outer').hide();
  });

  $('.tb_atc_btn').click(function(evt){
    evt.preventDefault();

    var dataId = $(this).attr('data-id');
    $('.tb_popup_outer[data-id="'+dataId+'"]').css('display', 'flex');
  });

  $('.tb_atc_btn_main').click(function(evt){
    evt.preventDefault();
    var fullTitle = '';
    $(this).closest('.tb_popup').find('.tb_select').each(function(){
      var data_title = $(this).val();
      fullTitle = fullTitle + '-' + data_title;
    });
  
    fullTitle = fullTitle.substring(1);
    var dataId;
    $(this).closest('.tb_popup').find('.tb_variant__js').each(function(){
      if ($(this).attr('data-title') == fullTitle){
        dataId = $(this).attr('data-id');
      }
    });

    var items = [];
    items.push({ id: dataId, quantity: 1 });

    // First, clear the cart
    $.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function() {
        // After the cart is cleared, add the new item
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: items,
          },
          dataType: "json",
          success: function (data) {
            window.location.href = '/checkout';
          },
        });
      }
    });
    
    console.log(fullTitle, dataId);
});

  
  $('.tb_primary_btn').click(function(evt){
    evt.preventDefault();
    $('html, body').animate({
        scrollTop: $(".tb_product_outer").offset().top
    }, 500);
  });

  $('.tbs_accordion_line').click(function(){
    $(this).toggleClass('active');
    $(this).find('.tbs_accordion_info').slideToggle();
  });

  $('.tb_product_desc').click(function(){
    $(this).toggleClass('active');
    $(this).find('.tb_body').slideToggle();
  });

  
  $('.tb_gallery_outer').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '200px',
    autoplay: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          centerPadding: '100px'
        }
      },
      {
        breakpoint: 600,
        settings: {
          centerPadding: '60px',
          slidesToShow: 1
        }
      }
    ]
  });


  $('.tbss_grid').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0626/9576/8321/files/Icon_ionic-ios-arrow-dropleft.png?v=1726726943'/></button>",
    nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0626/9576/8321/files/Icon_ionic-ios-arrow-dropleft-1.png?v=1726726943'/></button>",
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: true
        }
      }
    ]
  });


  $('.tb_reviews_grid.Mobile_only').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });
  
  
  
});